import { useSelector } from 'react-redux';
import { getSelectedSiteCollaborateInfo } from '../store/siteInfoSlice';
import { getUser } from '../store/userSlice';

const useShowAI = () => {
  const user = useSelector(getUser);
  const collaborateInfo = useSelector(getSelectedSiteCollaborateInfo);

  return Boolean(
    user?.additional_reviews > 0 &&
      collaborateInfo?.result.role.toLowerCase() !== 'collaborator'
  );
};

export default useShowAI;
